import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=5131b48a&scoped=true"
import script from "./CampaignView.vue?vue&type=script&lang=js"
export * from "./CampaignView.vue?vue&type=script&lang=js"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=5131b48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131b48a",
  null
  
)

export default component.exports